export default __webpack_public_path__ + "static/media/QV_NoExtrusion.17d85d6a.jpg";